import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function PaymentResult({ kind = "success" }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (kind !== "success" || !sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (tries >= 8) { setStatus("timeout"); return; }
        setTries(t => t + 1);
        setTimeout(poll, 2000);
      } catch { if (!cancelled) setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
  // eslint-disable-next-line
  }, [sessionId]);

  const STATUS_TEXT = {
    paid: "PAYÉ ✓",
    expired: "EXPIRÉ",
    timeout: "DÉLAI DÉPASSÉ",
    error: "ERREUR",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="brut-card p-8 max-w-md w-full text-center" data-testid={`payment-${kind}`}>
        <p className="font-mono-eyebrow">// Paiement</p>
        {kind === "cancel" ? (
          <>
            <h1 className="font-display text-4xl mt-2">ANNULÉ</h1>
            <p className="mt-3">Aucun montant n'a été prélevé.</p>
          </>
        ) : status === "paid" ? (
          <>
            <h1 className="font-display text-4xl mt-2">PAYÉ ✓</h1>
            <p className="mt-3">Merci d'avoir voyagé avec TAXI/X.</p>
          </>
        ) : status === "checking" ? (
          <>
            <h1 className="font-display text-4xl mt-2">TRAITEMENT...</h1>
            <p className="font-mono-eyebrow mt-3 overflow-hidden"><span className="marquee-text">CONFIRMATION DU PAIEMENT · CONFIRMATION DU PAIEMENT ·</span></p>
          </>
        ) : (
          <h1 className="font-display text-4xl mt-2">{STATUS_TEXT[status] || status.toUpperCase()}</h1>
        )}
        <button data-testid="payment-back-btn" onClick={() => navigate("/passenger")} className="brut-btn mt-6">Retour à l'app →</button>
      </div>
    </div>
  );
}
